module.exports = __webpack_public_path__ + "static/media/headerLogo.b2d3e519.png";